// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"a2eef624","204":"6ff72f9c","463":"18e5bbec","512":"0776f4e6","525":"a1a937e8","814":"410874c6","862":"9374fa0e","956":"41a4b25a"}[chunkId] + ".chunk.js";
};